var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 24C42.5 34.2173 34.2173 42.5 24 42.5V45.5C35.8741 45.5 45.5 35.8741 45.5 24H42.5ZM24 42.5C13.7827 42.5 5.5 34.2173 5.5 24H2.5C2.5 35.8741 12.1259 45.5 24 45.5V42.5ZM5.5 24C5.5 13.7827 13.7827 5.5 24 5.5V2.5C12.1259 2.5 2.5 12.1259 2.5 24H5.5ZM24 5.5C34.2173 5.5 42.5 13.7827 42.5 24H45.5C45.5 12.1259 35.8741 2.5 24 2.5V5.5Z",
    fill: "url(#paint0_linear_63_9803)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 12C25.5 11.1716 24.8284 10.5 24 10.5C23.1716 10.5 22.5 11.1716 22.5 12H25.5ZM24 24H22.5C22.5 24.5682 22.821 25.0876 23.3292 25.3416L24 24ZM31.3292 29.3416C32.0701 29.7121 32.9712 29.4118 33.3416 28.6708C33.7121 27.9299 33.4118 27.0288 32.6708 26.6584L31.3292 29.3416ZM22.5 12V24H25.5V12H22.5ZM23.3292 25.3416L31.3292 29.3416L32.6708 26.6584L24.6708 22.6584L23.3292 25.3416Z",
    fill: "url(#paint1_linear_63_9803)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_63_9803",
    x1: 3.04348,
    y1: 4,
    x2: 41.1506,
    y2: 46.3783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45115,
    stopColor: "#A8F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_63_9803",
    x1: 23.8087,
    y1: 12,
    x2: 36.8299,
    y2: 19.2403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45115,
    stopColor: "#A8F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.1083be294092288340f3737c322db3d7.svg";
export { ForwardRef as ReactComponent };